// extracted by mini-css-extract-plugin
export default {"container":"ToggleTokens_container__DPdXv","token":"ToggleTokens_token__eXaJh","activeToken":"ToggleTokens_activeToken__AXtO7"};